<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
	  <IndexHeader></IndexHeader>
        <div class="widget-heading d-block">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-flex align-items-center">
              <h4 class="me-3 my-0">Lista jednostek</h4>
              <Link class="btn btn-outline-primary btn-sm" :href="route('articles.index')">Lista artykułów</Link>
            </div>
          </div>
        </div>

        <div class="widget-content">
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
              <tr>
                <th style="max-width: 100px">Nazwa</th>
                <th style="max-width: 120px">Kolejność</th>
                <th>Ilości dziesiętne</th>
                <th>Ilość artykułów w kategorii</th>
                <th>Akcje</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(unit, index) in units" :key="unit.id">
                <td style="max-width: 100px">
                  <input v-if="unit.isEditing" v-model="unit.edited_name" class="form-control"/>
                  <span v-else>{{ unit.name }}</span>
                </td>
                <td style="max-width: 120px">
                  <input v-if="unit.isEditing" v-model="unit.edited_sort" class="form-control" type="number"/>
                  <span v-else>{{ unit.sort }}</span>
                </td>
                <td>
                  <template v-if="unit.isEditing">
                    <select v-model="unit.edited_allow_decimal" class="form-select form-select-sm">
                      <option :value="1">Tak</option>
                      <option :value="0">Nie</option>
                    </select>
                  </template>
                  <template v-else>
                    <span v-if="unit.allow_decimal">Tak</span>
                    <span v-else>Nie</span>
                  </template>
                </td>
                <td>{{ unit.articles_count }}</td>
                <td>
                  <button v-if="!unit.isEditing" @click="editUnit(unit)" type="button" class="btn btn-sm btn-warning">
                    Edytuj
                  </button>
                  <button v-if="unit.isEditing" @click="saveUnit(unit)" type="button" class="btn btn-sm btn-primary">
                    <i class="bi bi-save me-1"></i>Zapisz
                  </button>
                  <button v-if="unit.isEditing" @click="cancelEdit(unit, index)" type="button"
                          class="btn btn-sm btn-outline-primary ms-2">
                    <i class="bi bi-x-circle me-1"></i>Anuluj
                  </button>
                  <button v-if="!unit.isEditing && unit.articles_count < 1" @click="deleteUnit(unit)" type="button"
                          class="btn btn-sm btn-danger ms-2">Usuń
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <button v-if="!this.isCreatingNewUnit" class="btn btn-sm btn-outline-success" type="button"
                    @click="createUnit">
              Utwórz nowy
            </button>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "../../../../Layouts/App.vue";
import {useForm} from "@inertiajs/vue3";
import IndexHeader from "@/Pages/Warehouses/Articles/IndexHeader.vue";

export default {
  components: {
    AppLayout,
	IndexHeader,
  },

  props: {
    units: Array,
  },

  data() {
    return {
      isCreatingNewUnit: false,
      form: useForm({
        name: null,
        sort: null,
        allow_decimal: null,
      }),
    };
  },

  methods: {
    // Włącza tryb edycji dla wybranego wiersza i zapisuje oryginalne wartości
    editUnit(unit) {
      this.units.forEach((u) => {
        this.$set(u, "isEditing", false);
      });
      this.$set(unit, "isEditing", true);
      this.$set(unit, "edited_name", unit.name);
      this.$set(unit, "edited_sort", unit.sort);
      this.$set(unit, "edited_allow_decimal", unit.allow_decimal);
    },

    // Anuluje edycję i przywraca oryginalne wartości
    cancelEdit(unit, index) {
      if (!unit.id) {
        this.units.splice(index, 1);
        this.isCreatingNewUnit = false;
      } else {
        unit.isEditing = false;
        unit.edited_name = unit.name;
        unit.edited_sort = unit.sort;
        unit.edited_allow_decimal = unit.allow_decimal;
      }
    },

    // Zapisuje zmiany do serwera
    saveUnit(unit) {
      this.form.name = unit.edited_name;
      this.form.sort = unit.edited_sort;
      this.form.allow_decimal = unit.edited_allow_decimal;

      if (!unit.id) {
        // Jeśli to nowy wiersz, użyj form.post
        this.form.post(route('articles.units.store'), {
          preserveScroll: true,
          onSuccess: () => {
            this.$set(unit, "isEditing", false);
          },
        });
      } else {
        // Jeśli to istniejący wiersz, użyj form.put
        this.form.put(route('articles.units.update', unit.id), {
          preserveScroll: true,
          onSuccess: () => {
            this.$set(unit, "isEditing", false);
          },
        });
      }
    },

    deleteUnit(unit) {
      this.form.delete(route('articles.units.destroy', unit.id), {
        preserveScroll: true,
      });
    },

    // Dodaje nowy wiersz do tabeli
    createUnit() {
      const newUnit = {
        id: null, // Nowy wiersz nie ma jeszcze ID
        name: "",
        sort: "",
        allow_decimal: 1,
        articles_count: 0,
        isEditing: true,
        edited_name: "",
        edited_sort: "",
        edited_allow_decimal: "",
      };
      this.units.push(newUnit);
      this.isCreatingNewUnit = true;
    },
  },
};
</script>
